import { render, staticRenderFns } from "./TopicDashboard.vue?vue&type=template&id=60207304&scoped=true"
import script from "./TopicDashboard.vue?vue&type=script&lang=js"
export * from "./TopicDashboard.vue?vue&type=script&lang=js"
import style0 from "./TopicDashboard.vue?vue&type=style&index=0&id=60207304&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60207304",
  null
  
)

export default component.exports